import actionTypes from 'state/actionTypes'
import errorsAction from 'state/actions/commonActions'
import { startLoadingAction, endLoadingAction, appResetAction, setRoutes } from 'state/actions/appActions'
import { HTTP_OLD_SA, V1ApiUsersClient } from 'core/http-common'
import { IRootState } from 'types'
import { ThunkAction } from 'redux-thunk'
import { getToken, setToken } from 'core/helpers'
import { ApiResponseDto, MultiFactorVerifiedDto, LoginDto } from '@v1UsersApi'
import { UnknownAction } from 'redux'
import { NavigateFunction } from 'react-router-dom'

export const loginAction = (dto: LoginDto)
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async (dispatch, getState) => {
        try {
            dispatch(startLoadingAction())
            dispatch({ type: actionTypes.LOGIN_START })
            const response = await V1ApiUsersClient.login(dto)
            if (process.env.REACT_APP_ENABLE_OLD_SA_INTEGRATION === 'true') {
                await oldSystemAdminLogin(dto)
            }

            setToken(response.token)
            const routeResponse = await V1ApiUsersClient.getMenuRoutes()
            await dispatch(setRoutes(routeResponse.data))
            await dispatch({ type: actionTypes.LOGIN_SUCCESS, payload: response })
        }
        catch (e) {
            return dispatch(errorsAction(e, actionTypes.LOGIN_FAILED))
        }
        finally { dispatch(endLoadingAction()) }
    }

export const logoutAction = (navigate: NavigateFunction)
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async (dispatch, getState) => {
        try {
            await dispatch(startLoadingAction())
            setTimeout(async () => {
                await dispatch({ type: actionTypes.LOGOUT_START })
                await V1ApiUsersClient.logout()
                if (process.env.REACT_APP_ENABLE_OLD_SA_INTEGRATION === 'true') {
                    await oldSystemAdminLogout()
                }
                await dispatch({ type: actionTypes.LOGOUT_SUCCESS })
                navigate(process.env.REACT_APP_LOGIN_REDIRECT!)
                await dispatch(endLoadingAction())
            })
        }
        catch (e) {
            return dispatch(errorsAction(e as ApiResponseDto, actionTypes.LOGOUT_FAILED))

        }
    }

export const expireSessionAction = (errors: Array<string>)
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async (dispatch) => {
        try {
            await dispatch(startLoadingAction())
            await dispatch({ type: actionTypes.EXPIRE_SESSION_SUCCESS, payload: { errors } })
        }
        catch (e) {
            dispatch(errorsAction(e as ApiResponseDto, actionTypes.EXPIRE_SESSION_FAILED))
        }
        finally {
            dispatch(endLoadingAction())
        }
    }

export const verifyTokenAction = ()
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async (dispatch, getState) => {
        try {
            await dispatch(startLoadingAction())
            await dispatch({ type: actionTypes.VERIFY_TOKEN_START })
            getToken()
            const response = await V1ApiUsersClient.verifyToken()
            await dispatch({
                type: actionTypes.VERIFY_TOKEN_SUCCESS,
                payload: response
            })
        }
        catch (e) {
            dispatch(errorsAction(e as ApiResponseDto, actionTypes.VERIFY_TOKEN_FAILED))
            dispatch(appResetAction())
        }
        finally { dispatch(endLoadingAction()) }
    }

export const setMultFactorVerified = (multiFactorVerified: MultiFactorVerifiedDto)
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async dispatch => dispatch({ type: actionTypes.USER_MULTI_FACTOR_VERIFIED, payload: { ...multiFactorVerified } })

const oldSystemAdminLogin = async (dto: LoginDto) => HTTP_OLD_SA.post('/api/login', dto)
const oldSystemAdminLogout = async () => HTTP_OLD_SA.get('/api/logout')